import { create } from 'zustand';
import { soundEngine } from '../lib/soundEngine';

interface SoundStore {
  muted: boolean;
  volume: number;
  toggleMute: () => void;
  setVolume: (v: number) => void;
}

export const useSoundStore = create<SoundStore>((set, get) => ({
  muted: true,
  volume: 0.3,

  toggleMute: () => {
    const next = !get().muted;
    soundEngine.setMuted(next);
    set({ muted: next });
  },

  setVolume: (v: number) => {
    soundEngine.setVolume(v);
    set({ volume: v });
  },
}));
